<template>
  <div class="left-rail">
    <button
      type="button"
      class="left-rail__btn"
      :class="{ 'left-rail__btn--active': panels.sidebar }"
      :data-tip="panels.sidebar ? 'Ocultar alertas y monitoreo' : 'Mostrar alertas y monitoreo'"
      data-tip-pos="right"
      @click="$emit('toggle', 'sidebar')"
    >
      <span class="left-rail__icon-wrap">
        <v-icon small class="left-rail__icon">mdi-bell-alert</v-icon>
        <span
          v-if="alertsCount > 0"
          class="left-rail__badge left-rail__badge--error"
        >{{ alertsCount }}</span>
      </span>
      <span class="left-rail__label">Alertas</span>
    </button>

    <button
      v-if="sosExists"
      type="button"
      class="left-rail__btn"
      :class="{ 'left-rail__btn--active': panels.sosLeft }"
      :data-tip="panels.sosLeft ? 'Ocultar SOS Colibri' : 'Mostrar SOS Colibri'"
      data-tip-pos="right"
      @click="$emit('toggle', 'sos')"
    >
      <span class="left-rail__icon-wrap">
        <v-icon small class="left-rail__icon">mdi-phone-in-talk</v-icon>
      </span>
      <span class="left-rail__label">SOS</span>
    </button>

    <button
      v-if="murphyExists"
      type="button"
      class="left-rail__btn"
      :class="{ 'left-rail__btn--active': panels.murphyDrawer }"
      :data-tip="murphyTooltip"
      data-tip-pos="right"
      @click="$emit('toggle', 'murphy')"
    >
      <span class="left-rail__icon-wrap">
        <span class="left-rail__icon left-rail__icon--murphy">
          <murphy-logo variant="mark" />
        </span>
        <span
          v-if="murphyPinnedCount > 0"
          class="left-rail__badge"
        >{{ murphyPinnedCount }}</span>
      </span>
      <span class="left-rail__label">Murphy</span>
    </button>

    <!-- SmartSearch es exclusivo: al abrirlo se colapsan los demás y al
         abrir cualquiera de los demás se colapsa él (lógica en SET_PANEL
         del store). Ancho del panel = 2 sidebars apilados. -->
    <button
      type="button"
      class="left-rail__btn"
      :class="{ 'left-rail__btn--active': panels.smartSearch }"
      :data-tip="panels.smartSearch ? 'Ocultar búsqueda inteligente' : 'Búsqueda inteligente'"
      data-tip-pos="right"
      @click="$emit('toggle', 'smartSearch')"
    >
      <span class="left-rail__icon-wrap">
        <v-icon small class="left-rail__icon">mdi-auto-fix</v-icon>
      </span>
      <span class="left-rail__label">IA</span>
    </button>
  </div>
</template>

<script>
import MurphyLogo from '@/components/map-v2/utils/MurphyLogo.vue'

export default {
  name: 'LeftRail',

  components: { MurphyLogo },

  props: {
    panels: { type: Object, required: true },
    alertsCount: { type: Number, default: 0 },
    sosExists: { type: Boolean, default: false },
    murphyExists: { type: Boolean, default: false },
    murphyPinnedCount: { type: Number, default: 0 },
    hasMurphyResult: { type: Boolean, default: false },
  },

  computed: {
    murphyTooltip() {
      if (this.panels.murphyDrawer) return 'Ocultar Murphy'
      if (this.hasMurphyResult) return 'Mostrar Murphy'
      if (this.murphyPinnedCount > 0) return this.murphyPinnedCount + ' pines Murphy'
      return 'Murphy'
    },
  },
}
</script>

<style scoped>
.left-rail {
  display: flex;
  flex-direction: column;
  flex: 0 0 44px;
  width: 44px;
  align-self: stretch;
  min-height: 0;
  background: var(--kln-bg-surface, #0d1220);
  border-right: 1px solid var(--kln-border-dim);
  overflow: hidden;
}

.left-rail__btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  flex: 1 1 0;
  min-height: 60px;
  padding: 8px 2px;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--kln-border-dim);
  color: var(--kln-text-dim, rgba(255, 255, 255, 0.7));
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  font: inherit;
  text-align: center;
}

.left-rail__btn:hover {
  background: var(--kln-border-dim);
  color: var(--kln-text, #fff);
}

.left-rail__btn--active {
  background: var(--kln-accent-soft, rgba(0, 212, 255, 0.12));
  color: var(--kln-accent, #00D4FF);
  border-left: 2px solid var(--kln-accent, #00D4FF);
  padding-left: 0;
}

.left-rail__btn--active .left-rail__icon {
  color: var(--kln-accent, #00D4FF);
}

.left-rail__icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.left-rail__icon {
  opacity: 0.95;
  flex-shrink: 0;
}

.left-rail__icon--murphy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  line-height: 0;
}

.left-rail__label {
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.left-rail__badge {
  position: absolute;
  top: -6px;
  right: -10px;
  min-width: 16px;
  height: 14px;
  padding: 0 4px;
  background: var(--kln-accent, #00D4FF);
  color: #000;
  font-size: 9px;
  font-weight: 700;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  pointer-events: none;
}

.left-rail__badge--error {
  background: var(--kln-alert-danger, #e74c3c);
  color: #fff;
}
</style>
